import { render, staticRenderFns } from "./Dimensions.vue?vue&type=template&id=199ac2e6&scoped=true"
import script from "./Dimensions.vue?vue&type=script&lang=js"
export * from "./Dimensions.vue?vue&type=script&lang=js"
import style0 from "./Dimensions.vue?vue&type=style&index=0&id=199ac2e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ac2e6",
  null
  
)

export default component.exports